import { Building2, ShieldCheck, BookOpen, GraduationCap, Network } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";

const PILLARS = [
  { icon: Building2, title: "Hospital Support", desc: "Professional support for healthcare institutions and hospital management." },
  { icon: ShieldCheck, title: "Insurance & Cashless", desc: "Support and awareness around insurance, TPA and cashless healthcare processes." },
  { icon: BookOpen, title: "Healthcare Knowledge", desc: "Making important healthcare information easier to understand." },
  { icon: GraduationCap, title: "Healthcare Training", desc: "Developing practical skills for healthcare teams and professionals." },
  { icon: Network, title: "Healthcare Connect", desc: "Creating meaningful connections across the healthcare ecosystem." },
];

export const ValueStrip = () => (
  <section id="value" className="relative bg-white py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionTag index="01" label="Trust / Value" />
        <h2 className="font-display mt-6 max-w-2xl text-2xl font-bold tracking-tight text-[#0B3C5C] sm:text-3xl lg:text-4xl">
          A 360° Approach to Healthcare
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.08}>
            <div
              data-testid={`pillar-card-${i + 1}`}
              className="group h-full rounded-2xl border border-[#0B3C5C]/10 bg-[#EAF3F8]/60 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-teal-500/30 hover:shadow-xl hover:shadow-teal-900/20"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#5FA832]/10 transition-colors duration-300 group-hover:bg-[#5FA832]/20">
                <p.icon className="h-5 w-5 text-[#4C8F2F]" />
              </span>
              <h3 className="font-display mt-5 text-base font-semibold text-[#0B3C5C]">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#4A6B82]">{p.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
